import { render, staticRenderFns } from "./config.vue?vue&type=template&id=53e6f54d&scoped=true&"
import script from "./config.vue?vue&type=script&lang=js&"
export * from "./config.vue?vue&type=script&lang=js&"
import style0 from "./config.vue?vue&type=style&index=0&id=53e6f54d&scoped=true&lang=scss&"
import style1 from "./config.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53e6f54d",
  null
  
)

export default component.exports